import BluePrintDevelopment from './BlueprintDevelopment';
import DiscoverBanner from './DiscoverBanner';
import HeroSection from './HeroSection';
import { LandingPageStyled } from './landing-styles';
import OurStrength from './OurStrength';
import ProfessionalSlogan from './ProfessionalSlogan';
import SimpleSmart from './SimpleSmart';
import StrategicChoice from './StrategicChoice';
import WhyChooseUs from './WhyChooseUs';

const LandingPage = () => {
  return (
    <LandingPageStyled>
      <HeroSection />
      <ProfessionalSlogan />
      <DiscoverBanner />
      <StrategicChoice />
      <BluePrintDevelopment />
      <OurStrength />
      <WhyChooseUs />
      <SimpleSmart />
    </LandingPageStyled>
  );
};

export default LandingPage;
